'use client';
import React, { useEffect } from 'react';

export default function PhotoQuoteForm() {
  useEffect(() => {
    const w = 'https://tally.so/widgets/embed.js';
    const existing = document.querySelector(`script[src="${w}"]`);
    if (!existing) {
      const s = document.createElement('script');
      s.src = w;
      s.onload = () => {
        if (typeof (window as any).Tally !== 'undefined') {
          (window as any).Tally.loadEmbeds();
        }
      };
      s.onerror = () => {
        document.querySelectorAll('iframe[data-tally-src]:not([src])').forEach((el) => {
          const iframe = el as HTMLIFrameElement;
          iframe.src = iframe.dataset.tallySrc || '';
        });
      };
      document.body.appendChild(s);
    } else if (typeof (window as any).Tally !== 'undefined') {
      (window as any).Tally.loadEmbeds();
    }
  }, []);

  return (
    <section id="quote" className="py-10 md:py-14">
      {/* Section label */}
      <div
        className="inline-block px-3 py-1 mb-4"
        style={{ background: 'rgba(123,47,255,0.1)', border: '1px solid rgba(123,47,255,0.4)' }}
      >
        <span
          style={{
            fontFamily: 'Barlow Condensed, Arial, sans-serif',
            fontWeight: 900,
            fontSize: '11px',
            textTransform: 'uppercase',
            letterSpacing: '0.12em',
            color: '#7b2fff',
          }}
        >
          Faster Than a Form
        </span>
      </div>

      <div
        style={{
          border: '1px solid rgba(0,245,255,0.2)',
          overflow: 'hidden',
        }}
      >
        <div className="grid md:grid-cols-2">
          {/* Left: copy */}
          <div
            style={{
              background: 'linear-gradient(135deg, #0d0d2b 0%, #111130 100%)',
              padding: 'clamp(24px, 4vw, 48px)',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              position: 'relative',
              overflow: 'hidden',
            }}
          >
            <div
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '3px',
                background: 'linear-gradient(90deg, #7b2fff, #ff00ff)',
              }}
            />
            <h2
              style={{
                fontFamily: 'Barlow Condensed, Arial, sans-serif',
                fontWeight: 900,
                fontSize: 'clamp(28px, 4vw, 44px)',
                textTransform: 'uppercase',
                color: '#e0e8ff',
                lineHeight: 1.0,
                letterSpacing: '0.01em',
                marginBottom: '8px',
              }}
            >
              Send Us a Photo.
              <br />
              <span style={{ color: '#00f5ff', textShadow: '0 0 16px rgba(0,245,255,0.5)' }}>
                Get a Quote Fast.
              </span>
            </h2>
            <p style={{ fontSize: '14px', color: '#a0b0d8', lineHeight: 1.7, marginBottom: '20px' }}>
              Upload a photo of your vehicle and drop your email — we'll reply with a precise quote. No
              back-and-forth, no pressure.
            </p>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
              {['Real quote, not a range', 'Fast email response', 'No obligation, no pressure'].map(
                (point) => (
                  <div key={point} style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                    <span
                      style={{
                        background: 'rgba(0,245,255,0.1)',
                        color: '#00f5ff',
                        width: '18px',
                        height: '18px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: '10px',
                        fontWeight: 900,
                        flexShrink: 0,
                        border: '1px solid rgba(0,245,255,0.3)',
                      }}
                    >
                      ✔
                    </span>
                    <span style={{ fontSize: '13px', color: '#a0b0d8', fontWeight: 500 }}>{point}</span>
                  </div>
                )
              )}
            </div>
          </div>

          {/* Right: Tally embed */}
          <div
            style={{
              background: '#0d0d2b',
              borderLeft: '1px solid rgba(0,245,255,0.15)',
              position: 'relative',
            }}
          >
            <iframe
              data-tally-src="https://tally.so/embed/jarRY6?alignLeft=1&hideTitle=1&transparentBackground=1&dynamicHeight=1"
              loading="lazy"
              width="100%"
              height="852"
              frameBorder={0}
              marginHeight={0}
              marginWidth={0}
              title="Get a Quote"
              style={{
                display: 'block',
                colorScheme: 'dark',
              }}
            />
          </div>
        </div>
      </div>
    </section>
  );
}